export default class UpdateSeguimientoResultadoC3 {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idResultado, idSeguimiento, seguimiento) {
    return await this.#repository.update(idPersonal, idResultado, idSeguimiento, seguimiento)
  }
}
